export default "__VITE_ASSET__BQY8Rzzg__"